(function () {
  if (window.__saleHeroInit) return;
  window.__saleHeroInit = true;

  const COPIED_TEXT = 'Copied';
  const RESET_MS = 1500;

  function attach(el) {
    if (!el || el.__bound) return;
    el.__bound = true;
    const code = el.dataset.shCopy;
    if (!code) return;

    let copiedEl = el.querySelector('.sh-code__copied');
    if (!copiedEl) {
      copiedEl = document.createElement('span');
      copiedEl.className = 'sh-code__copied';
      copiedEl.textContent = COPIED_TEXT;
      el.appendChild(copiedEl);
    }

    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    el.setAttribute('aria-label', 'Copy code ' + code);

    let timer = null;
    function flash() {
      el.classList.add('sh-code--copied');
      clearTimeout(timer);
      timer = setTimeout(() => el.classList.remove('sh-code--copied'), RESET_MS);
    }

    function copy() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(flash).catch(flash);
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
        flash();
      }
    }

    el.addEventListener('click', copy);
    el.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); copy(); }
    });
  }

  function init() {
    document.querySelectorAll('[data-sh-copy]').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
